export enum RecaptchaConstants {
  SITE_KEY = '6LcUuscgAAAAABLLekt4st20LJ3dWEGhj6w9u-NY',
  BASE_URL = 'http://sparelabs.com',
}
